module.exports = __webpack_public_path__ + "18c7130699ad7a3fd005431cab4c9285.png";